<template>
    <div class="top-table-filter-container">
        <!-- Десктопная версия -->
        <div class="d-none d-md-block">
            <div class="green-filter d-flex mb-2" v-if="!showDatesFilter">
                <div 
                    v-for="(menu, index) in greenFilterMenu"
                    :key="index"
                    :class="menu.submenu && menu.submenu.length ? 'btn-group':'green-filter d-flex'"
                >
                    <span
                        :class="`${menu.submenu && menu.submenu.length ? 'green-dropdown mr-0':'green-link mr-2'} ${menu.active ? 'active' : ''}`"
                        @click="changeActive(index)"
                    >{{ menu.title }}</span>

                    <!-- Показываем стрелку и подменю только если есть submenu -->
                    <span
                        v-if="menu.submenu && menu.submenu.length"
                        :class="`green-arrow-dropdown dropdown-toggle dropdown-toggle-split ${menu.active ? 'active' : ''}`"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <span><i class="fas fa-caret-down"></i></span>
                    </span>
                    <div v-if="menu.submenu && menu.submenu.length" class="dropdown-menu">
                        <b-btn
                            variant="link"
                            v-for="(submenu, s_index) in menu.submenu"
                            :key="s_index"
                            :class="submenu.active ? 'dropdown-item active' : 'dropdown-item'"
                            @click="changeActive(index, s_index)"
                        >{{submenu.title}}</b-btn>
                    </div>
                </div>

                <b-button
                    title="Открыть фильтр по датам"
                    size="sm"
                    :variant="showDatesFilter ? 'primary' : 'secondary'"
                    id="filter-dates_off"
                    @click="showDatesFilter=!showDatesFilter"
                >
                    <b-icon icon="filter-square" scale="1" aria-label="Фильтр по датам"></b-icon>
                </b-button>
            </div>

            <!-- Цветные квадратики для быстрой фильтрации по статусам -->
            <div class="status-color-filters d-flex align-items-center mb-2">
                <span class="status-color-filters-title">Фильтр по цветам:</span>
                <div 
                    v-for="(filter, index) in statusColorFilters"
                    :key="index"
                    :class="`status-color-square ${filter.class} ${filter.active ? 'active' : ''}`"
                    :id="`status-filter-${index}`"
                    @click="toggleStatusFilter(index)"
                    v-b-tooltip.hover
                    :title="getStatusFilterTooltip(filter)"
                ></div>
            </div>

            <div class="green-filter green-filter-dates d-flex mb-2" v-if="showDatesFilter">    
                <b-button
                    title="Закрыть фильтр по датам"
                    size="sm"
                    class="mr-3"
                    :variant="showDatesFilter ? 'primary' : 'secondary'"
                    id="filter-dates_on"
                    @click="showDatesFilter=!showDatesFilter"
                >
                    <b-icon icon="filter-square" scale="1" aria-label="Фильтр по датам"></b-icon>
                </b-button>
                <div class="btn-group"
                    v-for="(menu, index) in greenSubFilterMenu"
                    :key="index"
                >
                    <span
                        :class="`green-dropdown green-dropdown-dates mr-2 ${menu.active ? 'active' : ''}`"
                        @click="changeSubmenuActive(index)"
                    >{{ menu.title }}</span>
                </div>
                <div class="input-group">
                    <input type="date" class="form-control start-input-date" v-model="period_start">
                    <input type="date" class="form-control finish-input-date" v-model="period_end">
                    <div class="input-group-append" id="button-addon4">
                        <button
                            :class="periodButtonActive ? 'btn btn-outline-secondary-period-input active' : 'btn btn-outline-secondary-period-input'"
                            type="button"
                            @click="changeSubmenuActive(-1)"
                        >Период</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Мобильная версия -->
        <div class="d-flex d-md-none mobile-filter-container">
            <!-- Бургер-меню -->
            <button 
                class="burger-menu-btn"
                @click="toggleMobileMenu"
                :class="{ active: isMobileMenuOpen }"
            >
                <span class="burger-line"></span>
                <span class="burger-line"></span>
                <span class="burger-line"></span>
            </button>

            <!-- Выпадающее меню -->
            <div class="mobile-dropdown" :class="{ show: isMobileMenuOpen }">
                <!-- Основные фильтры -->
                <div class="mobile-filter-section">
                    <h6 class="mobile-filter-title">Тип заказов</h6>
                    <div class="mobile-filter-items">
                        <div v-for="(menu, index) in greenFilterMenu" :key="index">
                            <!-- Если есть подменю -->
                            <div v-if="menu.submenu && menu.submenu.length">
                                <div class="mobile-filter-submenu">
                                    <span class="mobile-filter-submenu-title">{{ menu.title }}</span>
                                    <div class="mobile-filter-submenu-items">
                                        <span 
                                            v-for="(submenu, s_index) in menu.submenu"
                                            :key="s_index"
                                            :class="`mobile-filter-item ${submenu.active ? 'active' : ''}`"
                                            @click="changeActive(index, s_index); closeMobileMenu()"
                                        >
                                            {{ submenu.title }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <!-- Если нет подменю -->
                            <span 
                                v-else
                                :class="`mobile-filter-item ${menu.active ? 'active' : ''}`"
                                @click="changeActive(index); closeMobileMenu()"
                            >
                                {{ menu.title }}
                            </span>
                        </div>
                    </div>
                </div>

                <!-- Цветные квадратики для быстрой фильтрации по статусам -->
                <div class="mobile-filter-section">
                    <h6 class="mobile-filter-title">Фильтр по статусам</h6>
                    <div class="mobile-status-filters d-flex flex-wrap">
                        <div 
                            v-for="(filter, index) in statusColorFilters"
                            :key="index"
                            :class="`status-color-square ${filter.class} ${filter.active ? 'active' : ''}`"
                            :id="`mobile-status-filter-${index}`"
                            @click="toggleStatusFilter(index); closeMobileMenu()"
                            v-b-tooltip.hover
                            :title="getStatusFilterTooltip(filter)"
                        ></div>
                    </div>
                </div>

                <!-- Фильтр по датам -->
                <div class="mobile-filter-section">
                    <h6 class="mobile-filter-title">Фильтр по датам</h6>
                    <div class="mobile-filter-items">
                        <span 
                            :class="`mobile-filter-item ${showDatesFilter ? 'active' : ''}`"
                            @click="showDatesFilter = !showDatesFilter"
                        >
                            {{ showDatesFilter ? 'Скрыть фильтр' : 'Показать фильтр' }}
                        </span>
                        
                        <!-- Опции фильтра по датам внутри меню -->
                        <div v-if="showDatesFilter" class="mobile-filter-submenu">
                            <div class="mobile-filter-submenu-items">
                                <span 
                                    v-for="(menu, index) in greenSubFilterMenu"
                                    :key="index"
                                    :class="`mobile-filter-item ${menu.active ? 'active' : ''}`"
                                    @click="changeSubmenuActive(index); closeMobileMenu()"
                                >
                                    {{ menu.title }}
                                </span>
                                <span 
                                    :class="`mobile-filter-item ${periodButtonActive ? 'active' : ''}`"
                                    @click="changeSubmenuActive(-1); closeMobileMenu()"
                                >
                                    Период
                                </span>
                            </div>
                            
                            <!-- Поля дат внутри подменю -->
                            <div class="mobile-date-inputs">
                                <input type="date" class="form-control mb-2" v-model="period_start" placeholder="Начальная дата">
                                <input type="date" class="form-control mb-2" v-model="period_end" placeholder="Конечная дата">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

const agentFilterMenu = [
    {
        title: "Все",
        active: true,
        only_creator_user_orders: true,
    },
    {
        title: "Заявки",
        active: false,
        reference_order_type_id: 1,
        only_creator_user_orders: true,
    },
    {
        title: "Поставки",
        active: false,
        reference_order_type_id: 2,
        only_creator_user_orders: true,
    },
];

const leadObserverFilterMenu = [
    {
        title: "Лиды",
        active: true,
        submenu: [
            {
                title: "Все разрешённые лиды",
                active: true,
                reference_order_type_id: 1,
            },
        ]
    },
];

const fullFilterMenu = [
    {
        title: "Заказы",
        active: true,
        submenu: [
            {
                title: "Все заказы",
                active: true,
            },
            {
                title: "Мои заказы",
                active: false,
                only_creator_user_orders: true,
            },
        ]
    },
    {
        title: "Лиды",
        active: false,
        submenu: [
            {
                title: "Все лиды",
                active: false,
                reference_order_type_id: 1,
                reference_sources_id: 23,
            },
        ]
    },
    {
        title: "Заявки",
        active: false,
        submenu: [
            {
                title: "Все заявки",
                active: false,
                reference_order_type_id: 1,
            },
            {
                title: "Мои заявки",
                active: false,
                reference_order_type_id: 1,
                only_creator_user_orders: true,
            },
        ]
    },
    {
        title: "Поставки",
        active: false,
        submenu: [
            {
                title: "Все поставки",
                active: false,
                reference_order_type_id: 2,
            },
            {
                title: "Мои поставки",
                active: false,
                reference_order_type_id: 2,
                only_creator_user_orders: true,
            },
        ]
    },
];

export default {
    props: {
        api: { type: String, required: true },
    },
    data() {
        return {
            isMobileMenuOpen: false,
            greenFilterMenu: [],
            showDatesFilter: false,
            greenSubFilterMenu: [
                { title: 'Все', type: 'all', active: true },
                { title: 'Сегодня', type: 'today', active: false },
            ],
            period_start: '',
            period_end: '',
            periodButtonActive: false,
            additionalParameter: '',
            statusColorFilters: [
                {
                    class: 'table-secondary',
                    statusIds: [359, 360, 539, 540, 541, 542, 543, 544, 545, 557], // Статусы "В работе"
                    active: false,
                    tooltip: 'В работе'
                },
                {
                    class: 'table-pre-success',
                    statusIds: [361],
                    active: false,
                    tooltip: ''
                },
                {
                    class: 'table-warning',
                    statusIds: [424],
                    active: false,
                    tooltip: ''
                },
                {
                    class: 'table-success',
                    statusIds: [421],
                    active: false,
                    tooltip: ''
                },
                {
                    class: 'table-danger',
                    statusIds: [362, 959],
                    active: false,
                    tooltip: ''
                }
            ],
        };
    },
    computed: {
        ...mapGetters("auth", ["currentUser", "isAuthenticated"]),

        isAgentAccount() {
            return this.currentUser.role && this.currentUser.role.includes("agent");
        },
        isLeadObserver() {
            return this.currentUser.role && this.currentUser.role.includes("lead-observer");
        }
    },
    mounted() {
        if (this.isLeadObserver) {
            this.greenFilterMenu = JSON.parse(JSON.stringify(leadObserverFilterMenu));
            this.changeActive(0, 0);
        } else {
            this.greenFilterMenu = JSON.parse(JSON.stringify(
                this.isAgentAccount ? agentFilterMenu : fullFilterMenu
            ));
            const startSettings = this.$store.state.userLocalSettings.filterSettings.orderTable.split(',');
            this.changeActive(parseInt(startSettings[0]), parseInt(startSettings[1]));
        }

        // Инициализация подсказок для цветных квадратиков
        // Используем $nextTick чтобы дождаться загрузки данных из store
        this.$nextTick(() => {
            this.initializeStatusTooltips();
        });
    },
    methods: {
        changeActive(activeIndex, submenuIndex = -1) {
            const menu = this.greenFilterMenu[activeIndex];

            // Если у пункта есть подменю, и submenuIndex не передан — вызываем метод заново с первым подпунктом
            if (submenuIndex === -1 && menu.submenu && menu.submenu.length) {
                return this.changeActive(activeIndex, 0);
            }

            let additionalParameter = '';
            this.period_start = '';
            this.period_end = '';
            this.changeSubmenuActive(0, true);

            this.$store.commit("userLocalSettings/SET_FILTER_SETTINGS", {
                name: 'orderTable',
                value: `${activeIndex},${submenuIndex}`
            });

            // Сначала деактивируем все меню и все подменю
            this.greenFilterMenu.forEach((menu, index) => {
                menu.active = false;
                if (menu.submenu) {
                    menu.submenu.forEach((submenu) => {
                        submenu.active = false;
                    });
                }
            });

            // Теперь активируем нужное меню и подменю
            this.greenFilterMenu.forEach((menu, index) => {
                if (index === activeIndex) {
                    menu.active = true;

                    if (!menu.submenu) {
                        if (menu.reference_order_type_id) {
                            additionalParameter += '&reference_order_type_id=' + menu.reference_order_type_id;
                        }
                        if (menu.reference_sources_id) {
                            additionalParameter += '&reference_sources_id=' + menu.reference_sources_id;
                        }
                        if (menu.only_creator_user_orders) {
                            additionalParameter += '&only_creator_user_orders=' + menu.only_creator_user_orders;
                        }
                    } else {
                        menu.submenu.forEach((submenu, s_index) => {
                            if (s_index === submenuIndex) {
                                submenu.active = true;
                                if (submenu.reference_order_type_id) {
                                    additionalParameter += '&reference_order_type_id=' + submenu.reference_order_type_id;
                                }
                                if (submenu.reference_sources_id) {
                                    additionalParameter += '&reference_sources_id=' + submenu.reference_sources_id;
                                }
                                if (submenu.only_creator_user_orders) {
                                    additionalParameter += '&only_creator_user_orders=' + submenu.only_creator_user_orders;
                                }
                            }
                        });
                    }
                }
            });

            // Сохраняем базовый параметр и добавляем статусный фильтр, если он активен
            this.additionalParameter = additionalParameter;
            this.applyStatusFilter();
        },
        changeSubmenuActive(activeIndex, silent = false) {
            this.greenSubFilterMenu.forEach((item, index) => {
                item.active = index === activeIndex;
            });

            this.periodButtonActive = activeIndex === -1;

            if (activeIndex === 1) {
                this.period_start = this.getCurrentDate();
                this.period_end = this.period_start;
            } else if (activeIndex !== -1) {
                this.period_start = '';
                this.period_end = '';
            }

            if (!silent) {
                this.sendDateIntervalRequest();
            }
        },
        sendDateIntervalRequest() {
            let additionalParameter = this.additionalParameter;
            additionalParameter += `&period_start=${this.period_start}&period_end=${this.period_end}`;
            
            // Добавляем статусный фильтр, если он активен
            const activeFilter = this.statusColorFilters.find(f => f.active);
            if (activeFilter && activeFilter.statusIds.length > 0) {
                additionalParameter += `&reference_order_status_id=${activeFilter.statusIds.join(',')}`;
            }
            
            this.$emit('setFilteringApiParameter', additionalParameter);
        },
        getCurrentDate() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        // Методы для мобильного меню
        toggleMobileMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
        },

        closeMobileMenu() {
            this.isMobileMenuOpen = false;
        },
        initializeStatusTooltips() {
            // Метод оставлен для совместимости, но теперь статусы заданы статически
            // Подсказки будут формироваться динамически в getStatusFilterTooltip
        },
        getStatusFilterTooltip(filter) {
            // Получаем названия статусов из store
            const statusProperties = this.$store.getters.GROUPED_REFERENCE_PROPERTIES;
            
            // Проверяем, что данные загружены
            if (!statusProperties || !statusProperties[35]) {
                // Если данные еще не загружены, возвращаем базовую информацию
                if (filter.statusIds.length > 0) {
                    return `Статусы: ${filter.statusIds.join(', ')}`;
                }
                return 'Все остальные статусы';
            }
            
            const orderStatuses = statusProperties[35];
            
            if (filter.statusIds.length > 0) {
                const statusNames = filter.statusIds.map(id => {
                    // Структура данных: orderStatuses[status].id и orderStatuses[status].name
                    // Ищем статус по id в объекте
                    let status = null;
                    if (typeof orderStatuses === 'object') {
                        // Проходим по всем ключам объекта и ищем по id
                        for (let key in orderStatuses) {
                            if (orderStatuses[key] && orderStatuses[key].id === id) {
                                status = orderStatuses[key];
                                break;
                            }
                        }
                    }
                    return status ? status.name : `Статус ${id}`;
                });
                
                // Формируем информативную подсказку
                const colorName = this.getColorName(filter.class);
                return `${colorName}: ${statusNames.join(', ')}`;
            } else {
                // Для серого квадратика (все остальные статусы)
                // Если статусы уже загружены, показываем их список
                if (filter.statusIds && filter.statusIds.length > 0) {
                    const statusNames = filter.statusIds.map(id => {
                        let status = null;
                        if (typeof orderStatuses === 'object') {
                            for (let key in orderStatuses) {
                                if (orderStatuses[key] && orderStatuses[key].id === id) {
                                    status = orderStatuses[key];
                                    break;
                                }
                            }
                        }
                        return status ? status.name : `Статус ${id}`;
                    });
                    // Показываем первые несколько статусов, если их много
                    if (statusNames.length > 5) {
                        return `Серый: ${statusNames.slice(0, 5).join(', ')} и еще ${statusNames.length - 5} статусов`;
                    }
                    return `Серый: ${statusNames.join(', ')}`;
                }
                return 'Все остальные статусы';
            }
        },
        getColorName(className) {
            const colorMap = {
                'table-success': 'Зеленый',
                'table-danger': 'Красный',
                'table-warning': 'Желтый',
                'table-pre-success': 'Светло-зеленый',
                'table-secondary': 'Серый'
            };
            return colorMap[className] || 'Неизвестный';
        },
        toggleStatusFilter(index) {
            const filter = this.statusColorFilters[index];
            
            // Переключаем состояние фильтра (можно выбирать несколько)
            filter.active = !filter.active;
            
            this.applyStatusFilter();
        },
        applyStatusFilter() {
            // Находим все активные фильтры
            const activeFilters = this.statusColorFilters.filter(f => f.active);
            
            let additionalParameter = this.additionalParameter;
            
            // Удаляем предыдущий фильтр по статусам из параметров
            // Находим и удаляем reference_order_status_id из строки
            additionalParameter = additionalParameter.replace(/&reference_order_status_id=[^&]*/g, '');
            
            // Объединяем статусы из всех активных фильтров
            if (activeFilters.length > 0) {
                const allStatusIds = new Set();
                
                activeFilters.forEach(filter => {
                    if (filter.statusIds && filter.statusIds.length > 0) {
                        filter.statusIds.forEach(id => allStatusIds.add(id));
                    }
                });
                
                // Если есть статусы, добавляем их в параметры
                if (allStatusIds.size > 0) {
                    additionalParameter += `&reference_order_status_id=${Array.from(allStatusIds).join(',')}`;
                }
            }
            
            this.$emit('setFilteringApiParameter', additionalParameter);
        }
    }
}
</script>

<style scoped>
.green-dropdown-dates, .green-filter-dates > span, .green-filter-dates > a {
    border: 1px solid #EA7B27 !important;
    border-radius: 5px !important;
    padding: 2px 10px !important;
    color: #EA7B27 !important;
    cursor: pointer !important;
    white-space: nowrap !important;        
}
.green-filter-dates span.active, .green-filter-dates a.active, .btn-outline-secondary-period-input.active {
    border-color: #0D6247 !important;
    color: #0D6247 !important;
}

.status-color-filters-title {
    font-size: 12px;
    color: #5a6268;
    margin-right: 0;
    font-weight: normal;
}
/* Стили для цветных квадратиков фильтрации по статусам */
.status-color-filters {
    gap: 8px;
    position: absolute;
    bottom: -34px;
    left: 0;
    z-index: 9;
    width: 250px;
}

.status-color-square {
    width: 18px;
    height: 18px;
    border-radius: 4px;
    cursor: pointer;
    border: 2px solid transparent;
    transition: all 0.2s ease;
    position: relative;
    opacity: 0.4; /* По умолчанию бледные */
}

.status-color-square:hover {
    transform: scale(1.1);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    opacity: 0.7; /* При наведении немного ярче */
}

.status-color-square.active {
    border-color: #333;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
    opacity: 1; /* Активные - полностью яркие */
}

.status-color-square.table-success {
    background-color: #28a745;
}

.status-color-square.table-danger {
    background-color: #dc3545;
}

.status-color-square.table-warning {
    background-color: #ffc107;
}

.status-color-square.table-pre-success {
    background-color: #90ee90;
}

.status-color-square.table-secondary {
    background-color: #6c757d;
}

/* Мобильная версия */
.mobile-status-filters {
    gap: 12px;
    padding: 8px 0;
}

.mobile-status-filters .status-color-square {
    width: 32px;
    height: 32px;
}
</style>
